export function generateAvatar(user) {
    const avatarElement = document.querySelector('.user-avatar');
    let initial = user.name.charAt(2);
    if (djangoData.isUsenetUser) {
        initial = user.name.charAt(0);
    }
    avatarElement.style.backgroundColor = stringToColor(user.name);
    avatarElement.textContent = initial;
}

function stringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
}